module.exports = __webpack_public_path__ + "static/media/attach-icon.d4ae75d6.svg";